import React from 'react';
import { Loader2 } from 'lucide-react';
import { TD } from './tableStyles';
import type { HourlyState } from '../hourly';

/** What sits under an opened bucket while its hours load, or when there are none to show. */
const HourStatusRow: React.FC<{ state: HourlyState<unknown>; colSpan: number; hasRows: boolean }> = ({ state, colSpan, hasRows }) => {
  if (hasRows) return null;
  return (
    <tr className="border-t border-slate-50 dark:border-slate-700/50">
      <td colSpan={colSpan} className={`${TD} pl-9 text-slate-600`}>
        {state.loading ? <span className="inline-flex items-center gap-2"><Loader2 className="h-3.5 w-3.5 animate-spin" /> Loading hours…</span>
          : state.error ? <span className="text-rose-700">{state.error}. Click the bucket again to retry.</span>
          : state.data ? 'No activity in any hour for this selection.' : null}
      </td>
    </tr>
  );
};

export default HourStatusRow;
